import React from 'react';
import styles from './App.module.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import MicrosPaymentRequest from 'modules/PaymentRequest/MicrosPaymentRequest';
import SignupPage from 'modules/Signup/SignupPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import MainLayout from 'ui/Layout/MainLayout/MainLayout';

function App() {
    return (
        <div className={styles.app}>
            <MainLayout>
                <Routes>
                    <Route path="/" element={<Navigate to="404" replace />} />
                    <Route path="/submit-post/:uuid/" element={<MicrosPaymentRequest />} />
                    <Route path="/signup/" element={<SignupPage />} />
                    <Route path="*" element={<div>Page not found</div>} />
                </Routes>
            </MainLayout>
            <ToastContainer />
        </div>
    );
}

export default App;
